import { useKeyboardAwareContainer } from '@/hooks/useKeyboardAwareContainer';
import { useIsMobileViewport } from '@/hooks/useIsMobileViewport';

/**
 * Mobile sheet layout for Create List / Create Trip modals:
 * focus scroll inside gt-keyboard-scroll (not overlay backdrop).
 */
export function useCreateModalSheetLayout(): {
  setScrollRef: (el: HTMLDivElement | null) => void;
} {
  const isMobile = useIsMobileViewport();
  const { setContainerRef: setScrollRef } = useKeyboardAwareContainer({ enabled: isMobile });

  return { setScrollRef };
}
